<footer>
    © {{currentYear}} Funfigz Solution
</footer>
